import { Injectable } from '@angular/core';
import {
  CanActivate, CanLoad, Router,
  CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Route
} from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { SessionService } from 'app/resources/services/session-service.service';
import { SaldoService } from 'app/resources/services/saldo.service';
import { Response } from '@angular/http';
import { PoliticaTermoService } from './politica-termo.service';

declare var $: any;

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private sessionService: SessionService,
    private router: Router,
    private location: Location,
    private politicaTermoService: PoliticaTermoService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return new Observable<boolean>(observer => {
      if (this.sessionService.getAuthBasic() !== undefined) {
        if (url !== '/home' && url !== '/politicas-e-termos') {
          observer.next(this.politicaTermoService.isAcceptedPoliciesAndTerms());
          $('#myModalPolicesTerms').modal('show');
        } else {
          observer.next(true);
        }
      } else {
        observer.next(false);
        this.sessionService.invalidaSessao();
        this.router.navigate(['']);
      }
    });

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

  public interceptor(observable: Observable<any>): Observable<Response> {
    return new Observable<Response>(observer => {
      observable.subscribe(
        sucesso => {
          observer.next(sucesso);
        }, erro => {
          if (erro.status === 401) {
            this.sessionService.sessaoExpirada = true;
            this.sessionService.invalidaSessao();
            this.router.navigate(['']);
          } else {
            if (erro.status === 502) {
              erro._body = 'Não foi possivel estabelecer conexão com nosso parceiro.';
            } else if (erro.status === 500) {
              erro._body = 'Ocorreu um erro inesperado';
            } else if (erro.status === 404) {
              erro._body = 'Caminho não encontrado';
            } else if (erro.status === 0) {
              erro._body = 'Falha ao se comunicar com o servidor';
            }
            erro._body = 'Atenção! ' + erro._body;
            observer.error(erro);
          }
        }
      );
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/auth-guard.service.ts